import {Button, message, Modal, Row} from 'antd'
import {auth_updateFollowedCategories_Api} from 'apis'
import {compare, NullAsDefault} from "views/Shared";
import mapObject from 'helpers/mapObject'
import _ from 'lodash'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import {LocalContext} from 'modules/local/LocalContext'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useEffect, useMemo, useState} from 'react'
import {useSelector} from 'react-redux'
import {getAllPackages, getCurrentPackageIndex, getLogin,} from 'redux/selectors'
import AllCategoriesFilter from 'views/Category/components/AllCategoriesFilter'
import SelectCategoryGroup from 'views/Category/components/SelectCategoryGroup'
import 'views/SelectCategory'
import {useAppConfig} from '../../modules/local'
import '../Category/index.css'
import {DelayRender} from '../Discovery/DelayRender'
import {useRequiredLogin} from '../Server/useRequiredLogin'
import classNames from "classnames";
import dayjs from "dayjs";

export const SelectCategory = ({
                                   onSuccess = NullAsDefault,
                                   minItemNumber = 0,
                                   maxItemNumber = 99,
                               }) => {
    const t = useTranslate()
    const login = useSelector(getLogin)
    const [selectedItems, setSelectedItems] = useState(
        _.get(login, 'categories', []).reduce((result, value) => {
            result[value.id] = true
            return result
        }, {})
    )
    const handleRequiredLogin = useRequiredLogin()

    const {categories = []} = useAppConfig()

    const [values, setValues] = useState({
        keyword: '',
        following: false,
    })

    const {translate} = useContext(LocalContext)

    const restCount = Math.max(
        minItemNumber - mapObject(selectedItems).filter((item) => item).length,
        0
    )

    const [selectedCateNumber, setSelectedCateNumber] = useState(
        mapObject(selectedItems).filter((item) => item).length
    )

    const [toggleFinish, setToggleFinish] = useState(false)

    const currentSelectedCateNumber = mapObject(selectedItems).filter(
        (item) => item
    ).length
    useEffect(() => {
        if (
            currentSelectedCateNumber >=
            _.get(login, 'following_category_maximum', maxItemNumber) &&
            selectedCateNumber !== currentSelectedCateNumber
        ) {
            setSelectedCateNumber(currentSelectedCateNumber, setToggleFinish(true))
        }
        setSelectedCateNumber(currentSelectedCateNumber)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentSelectedCateNumber])

    const isValid =
        restCount === 0 &&
        mapObject(selectedItems, (value, key) => (value ? key : undefined)).filter(
            (item) => item
        ).length <= _.get(login, 'following_category_maximum', maxItemNumber)
    const handleSelectItem = (id) =>
        setSelectedItems({
            ...selectedItems,
            [id]: !selectedItems[id],
        })

    const updateCategoriesRequiredFields = useMemo(
        () => ({
            cate_ids: mapObject(selectedItems, (value, key) =>
                value ? key : undefined
            ).filter((item) => item),
        }),
        [selectedItems]
    )

    const {success, isLoading, handleAsyncAction} = useAsyncAction({
        apiInfo: auth_updateFollowedCategories_Api,
        values: updateCategoriesRequiredFields,
        onSuccess: () => {
            onSuccess()
            // history.replace('/')
        },
        onError: (...args) => message.error(_.get(args, '1.error')),
    })
    const dateObj = dayjs(
        _.get(login, 'following_category_available_change_at')
    )
    const isAfter = dateObj.isAfter(dayjs())

    const allPackages = getAllPackages(login) || []
    const current = getCurrentPackageIndex(login) || 0
    const currentPackage = _.get(allPackages, current) || {}

    const content = useMemo(() => {

        const current = categories.filter(
            ({id}) => !!!values.following || !!selectedItems[id]
        )
        const result = current.filter(({name}) => {
            return compare(name, values.keyword)
        })
        const groups = _.groupBy(result, ({name}) => name.charAt(0))

        return Object.keys(groups).map((name, index) => (
            <SelectCategoryGroup
                key={index}
                name={name}
                groups={groups}
                renderAction={(item) => {
                    const selected = selectedItems[item.id]
                    return (
                        <Button
                            color={selected ? "default" : "primary"} variant={selected ? 'filled' : 'solid'}
                            onClick={() => handleRequiredLogin(() => handleSelectItem(item.id))}
                            style={{fontSize: 14, padding: '2px 14px'}}
                            className={classNames(
                                "flex flex-center button-rounded-md no-border leading-tight",
                                !!selected ? 'text-color-300' : 'text-white'
                            )}>
                                <span className="font-medium text-sm">
                                    {translate(selected ? 'unfollow' : 'follow')}
                                </span>
                        </Button>
                    )
                }}
            />
        ))
    }, [categories, values, selectedItems])

    return (
        <div className="background max-w-5xl mx-auto w-full relative space-y-3">
            <div className="px-3 text-sm text-color-300 tracking-wider">
                {t('select categories description')}
            </div>
            <div className="px-3 font-semibold text-sm text-color-100 italic">
                {translate('which categories are your interests?')}
            </div>
            <AllCategoriesFilter
                onChange={(event) => {
                    const target = event.target
                    setValues({
                        ...values,
                        [target.name]: target.value,
                    })
                }}
                onRemoved={handleSelectItem}
                placeholders={() => 'filter'}
                following={values.following}
                selectedCategories={selectedItems}
                className="px-3 flex flex-wrap items-end justify-end"
            />
            <DelayRender>
                {() => (
                    <Row
                        wrap
                        gutter={[0, 10]}
                        className="p-3">
                        {content}
                    </Row>
                )}
            </DelayRender>
            <div className="w-full flex items-center gap-2 sticky bottom-0 z-20 border-t p-4 background">
                <div className="flex-1 font-semibold text-orange-600">
                    {(isAfter &&
                        dateObj.isValid() &&
                        _.template(
                            translate(
                                'you can not change your following categories before {time}',
                                {
                                    time: dateObj.calendar(),
                                }
                            )
                        )({
                            count: restCount,
                        })) ||
                    (!isValid &&
                        _.template(
                            translate('you can not follow more {n} categories', {
                                n: _.get(login, 'following_category_maximum', maxItemNumber),
                            })
                        )({
                            count: restCount,
                        })) ||
                    translate('After select, click Save to finish')}
                </div>
                <Button
                    color="primary" variant="solid"
                    onClick={() => {
                        if (_.isEmpty(selectedItems)) {
                            Modal.info({
                                title: translate('No categories have been selected'),
                                content: (
                                    <div>
                                        {translate('Please select at least 1 topic to complete. Kristo Network will help you find relevant information')}
                                    </div>
                                ),
                                onOk() {
                                },
                            })
                        } else {
                            handleAsyncAction(updateCategoriesRequiredFields)
                        }
                    }}
                    loading={isLoading}
                    disabled={!isValid || isAfter}
                    className="button-rounded-lg no-border">
                    {translate('save')}
                </Button>
            </div>
        </div>
    )
}

export default SelectCategory
